module.exports = __webpack_public_path__ + "static/media/bitmap.3919d27c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bitmap.png
// module id = 751
// module chunks = 0